import React, { useEffect, useState } from 'react';
import { api } from "../constants/api";

const ContactUsAdmin = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [contactData, setContactData] = useState<any>(null);
    const [form, setForm] = useState({
        email: '',
        contact: ''
    });
    const [isEdit, setIsEdit] = useState(false);

    // Fetch contact data
    const getContactData = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await api(true, '/getContactUs', 'get');
            setLoading(false);
            
            if (response.data.data && response.data.data.length > 0) {
                // Data exists, set edit mode
                const data = response.data.data[0]; // Assuming first record
                setContactData(data);
                setForm({
                    email: data.email || '',
                    contact: data.contact || ''
                });
                setIsEdit(true);
            } else {
                // No data, set create mode
                setContactData(null);
                setForm({ email: '', contact: '' });
                setIsEdit(false);
            }
        } catch (error: any) {
            console.log(error);
            setLoading(false);
            setError(error?.response?.data?.message || error.message || 'Error fetching contact data');
        }
    };

    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        
        if (name === 'contact') {
            // Only allow numbers and limit to 10 characters
            const numericValue = value.replace(/[^0-9]/g, '');
            if (numericValue.length <= 10) {
                setForm({ ...form, [name]: numericValue });
            }
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!form.email || !form.contact) {
            setError('Please fill in all fields');
            return;
        }

        // Validate contact number
        if (form.contact.length !== 10) {
            setError('Contact number must be exactly 10 digits');
            return;
        }

        if (!/^\d{10}$/.test(form.contact)) {
            setError('Contact number must contain only numbers');
            return;
        }

        try {
            setLoading(true);
            setError('');

            if (isEdit && contactData) {
                // Update existing contact
                await api(true, `/admin/updateContactUs/${contactData.id}`, 'put', {
                    data: form
                });
            } else {
                // Create new contact
                await api(true, '/admin/createContactUs', 'post', form);
            }

            // Refresh data after successful operation
            await getContactData();
            alert(isEdit ? 'Contact details updated successfully!' : 'Contact details created successfully!');
        } catch (error: any) {
            console.log(error);
            setError(error?.response?.data?.message || error.message || 'Error saving contact details');
        } finally {
            setLoading(false);
        }
    };

    // Load data on component mount
    useEffect(() => {
        getContactData();
    }, []);

    return (
        <div className='contact-us'>
            <div className="contact-us-page">
                <h1>Contact Us</h1>
                {error && (
                    <p style={{ color: 'red', marginBottom: '10px' }}>{error}</p>
                )}
                <div className="card">
                    <form className='form-part' onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '15px' }}>
                            <label htmlFor="email" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email :</label>
                            <input 
                                type="email" 
                                name="email" 
                                value={form.email} 
                                onChange={handleChange}
                                required
                                disabled={loading}
                                placeholder='Enter email'
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#eee', 
                                    border: '2px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <label htmlFor="contact" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Contact :</label>
                            <input 
                                type="tel" 
                                name='contact' 
                                value={form.contact} 
                                onChange={handleChange}
                                required
                                disabled={loading}
                                placeholder='Enter 10-digit contact number'
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#eee', 
                                    border: '2px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>
                        <div style={{ marginTop: '20px' }}>
                            <button 
                                type="submit" 
                                className="btn updt" 
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : (isEdit ? 'Update' : 'Save')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactUsAdmin;
